// extracted by mini-css-extract-plugin
export default {"page_title":"masters_page_title__J1x1A"};